// dependencies
import React, { Fragment } from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "aphrodite";

// components
import Text from "../Text";
import Locale from "../Locale";
import { List, ListItem } from "../List";
import { Row, Col } from "../Grid";
import Link from "../Link2";
import Stack from "../Stack";
import CustomerAvatar from "../Customer/Avatar";

// contexts
import { useConfiguration } from "../../contexts/configuration";

// utils
import stringObsfuscateContact from "@cloudspire/shared/utils/string/obfuscateContact";

// helpers
import { roomMayContactOwner } from "../../helpers/room";

const styles = StyleSheet.create({
  website: {
    color: "rgb(155, 155, 155)",
  },
});

function RoomOwner(props) {
  const { room } = props;

  const intl = useIntl();
  const configuration = useConfiguration();

  const website = room?.website;
  const customer = room?.customer;
  const isPro = room?.isPro;

  return (
    <>
      <List inline={true} gutter={1} style={{ alignItems: "center" }}>
        <ListItem>
          <CustomerAvatar customer={customer} />
        </ListItem>

        <ListItem style={{ flex: 1 }}>
          <Row
            breakpointList={{ sm: 700, md: Infinity }}
            col={{ sm: 1, md: 2 }}
          >
            <Col>
              <Text>{customer.firstname}</Text>
            </Col>

            {customer.locales.length > 0 && (
              <Col>
                <Text>
                  {intl.formatMessage({
                    defaultMessage: "Langues parlées :",
                  })}{" "}
                  {customer.locales.map((locale, index) => (
                    <Fragment key={locale}>
                      {index > 0 && <Text>{", "}</Text>}
                      <Locale locale={locale} />
                    </Fragment>
                  ))}
                </Text>
              </Col>
            )}

            <Col span={{ sm: 1, md: 2 }}>
              <Text>
                {intl.formatMessage(
                  {
                    defaultMessage:
                      "{isPro, select, true {Annonce professionnelle} other {Annonce d’un particulier}}",
                  },
                  { isPro }
                )}
              </Text>
            </Col>

            {roomMayContactOwner({ room, configuration }) && website && (
              <Col span={{ sm: 1, md: 2 }}>
                <Link
                  aStyle={styles.website}
                  to={website}
                  external={true}
                  target="_blank"
                >
                  {website}
                </Link>
              </Col>
            )}
          </Row>
        </ListItem>
      </List>
      {customer.about && (
        <>
          <Stack marginTop={1} />
          <Text>{stringObsfuscateContact(customer.about ?? "")}</Text>
        </>
      )}
    </>
  );
}

export default RoomOwner;
